import { AccountClosureReason } from '__generated__/GQL';
import Text from 'components/_core/Text';

import Title from '../../../../../components/Title';
import FormCheckboxGroup from '../../../FormCheckboxGroup';
import useRemoveUniqueReasonsIfNeeded from '../../hooks/useRemoveUniqueReasonsIfNeeded';
import locales from './locales';

const options = [
  {
    explanationFieldName: 'unsatisfiedMissingBankingServiceExplanation',
    reason: AccountClosureReason.UnsatisfiedMissingBankingService,
    title: locales[AccountClosureReason.UnsatisfiedMissingBankingService],
  },
  {
    explanationFieldName: 'unsatisfiedMissingFeatureExplanation',
    reason: AccountClosureReason.UnsatisfiedMissingFeature,
    title: locales[AccountClosureReason.UnsatisfiedMissingFeature],
  },
  {
    explanationFieldName: 'unsatisfiedPricingIssueExplanation',
    reason: AccountClosureReason.UnsatisfiedPricingIssue,
    title: locales[AccountClosureReason.UnsatisfiedPricingIssue],
  },
  {
    explanationFieldName: 'unsatisfiedBadBankingServiceExperienceExplanation',
    reason: AccountClosureReason.UnsatisfiedBadBankingServiceExperience,
    title: locales[AccountClosureReason.UnsatisfiedBadBankingServiceExperience],
  },
  {
    explanationFieldName: 'unsatisfiedBadSupportExperienceExplanation',
    reason: AccountClosureReason.UnsatisfiedBadSupportExperience,
    title: locales[AccountClosureReason.UnsatisfiedBadSupportExperience],
  },
  {
    explanationFieldName: 'unsatisfiedTechnicalIssueExplanation',
    reason: AccountClosureReason.UnsatisfiedTechnicalIssue,
    title: locales[AccountClosureReason.UnsatisfiedTechnicalIssue],
  },
  {
    explanationFieldName: 'unsatisfiedOtherExplanation',
    reason: AccountClosureReason.UnsatisfiedOther,
    title: locales[AccountClosureReason.UnsatisfiedOther],
  },
];

const UnsatisfiedOptions = () => {
  useRemoveUniqueReasonsIfNeeded();

  return (
    <>
      <Title>{locales.title}</Title>

      <Text fontSize="font-15" mb="space-40" size="sm">
        {locales.subtitle}
      </Text>

      <FormCheckboxGroup fieldName="reasons" options={options} />
    </>
  );
};

export default UnsatisfiedOptions;
